import React, { useState } from 'react';
import Input from '../../../../components/ui/Input';

const BirthdaySelector = ({ selectedBirthdate, onBirthdateChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const handleDateChange = (e) => {
        const dateValue = e.target.value;
        onBirthdateChange(dateValue);
    };

    const handleClear = () => {
        onBirthdateChange(null);
    };

    const getMaxDate = () => {
        // Don't allow birthdays in the future
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const getMinDate = () => {
        // Allow birthdays up to 120 years ago
        const oldest = new Date();
        oldest.setFullYear(oldest.getFullYear() - 120);
        return oldest.toISOString().split('T')[0];
    };

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between">
                <label className="text-sm font-medium text-accent-700">
                    Birthday (Optional)
                </label>
                {selectedBirthdate && (
                    <button
                        onClick={handleClear}
                        className="text-xs text-accent-500 hover:text-accent-700"
                    >
                        Clear
                    </button>
                )}
            </div>

            <div className="relative">
                <Input
                    type="date"
                    value={formatDateForInput(selectedBirthdate)}
                    onChange={handleDateChange}
                    min={getMinDate()}
                    max={getMaxDate()}
                    className="w-full"
                    placeholder="Select your birthday"
                />
            </div>

            {selectedBirthdate && (
                <div className="text-sm text-accent-600">
                    Selected: {formatDateForDisplay(selectedBirthdate)}
                </div>
            )}

            <div className="text-xs text-accent-500">
                We'll send you special birthday surprises! 🎂
            </div>
        </div>
    );
};

export default BirthdaySelector; 